import { styled } from '@attentive-platform/stem-ui';

export const OuterCard = styled('div')(() => ({
  background: '#fff',
  border: '1px solid rgb(226, 232, 240)',
  borderRadius: '0.5rem',
  padding: '1.5rem',
  width: '100%',
  maxWidth: '720px',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
}));

export const CompanyPill = styled('div')(() => ({
  background: '#ebf4ff',
  border: '1px solid #ebf4ff',
  padding: '0.5rem 0.75rem',
  borderRadius: '0.25rem',
  textAlign: 'center',
  fontSize: '0.875rem',
  color: '#2d3748'
}));

export const ConfigSummary = styled('div')(() => ({
  padding: '0.875rem 1.125rem',
  background: '#edf2f7',
  borderRadius: '0.25rem',
  fontSize: '0.75rem',
  display: 'flex',
  gap: '1.25rem',
  flexWrap: 'wrap'
}));

export const PostureTileWrapper = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  minWidth: '140px'
}));

export const FormBox = styled('div')(() => ({
  border: '1px solid #e2e8f0',
  borderRadius: '0.5rem',
  padding: '1rem'
}));

export const ToggleRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginBottom: '1rem'
}));

export const ToggleTrack = styled('label')(() => ({
  position: 'relative',
  display: 'inline-block',
  width: '40px',
  height: '24px',
  flexShrink: 0,
  marginTop: '2px',
  cursor: 'pointer',
  '& input': {
    opacity: 0,
    width: 0,
    height: 0,
    position: 'absolute'
  },
  '& span': {
    position: 'absolute',
    inset: 0,
    backgroundColor: '#cbd5e0',
    borderRadius: '9999px',
    transition: 'background-color 0.2s',
    '&::before': {
      content: '""',
      position: 'absolute',
      width: '20px',
      height: '20px',
      left: '2px',
      top: '2px',
      backgroundColor: '#fff',
      borderRadius: '50%',
      transition: 'transform 0.2s'
    }
  },
  '& input:checked + span': {
    backgroundColor: '#4299e1'
  },
  '& input:checked + span::before': {
    transform: 'translateX(16px)'
  }
}));

export const ToggleText = styled('div')(() => ({
  textAlign: 'left'
}));

export const EmailRow = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.5rem',
  width: '100%'
}));

export const FieldRow = styled('div')(() => ({
  display: 'flex',
  gap: '0.75rem',
  marginBottom: '1.25rem'
}));

export const FieldBoxContainer = styled('div')(({ readonly }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.25rem',
  padding: '0.75rem',
  border: '1px solid #e2e8f0',
  borderRadius: '0.5rem',
  flex: 1,
  background: readonly ? '#f7fafc' : '#fff'
}));

export const FieldLabel = styled('span')(() => ({
  fontSize: '0.75rem',
  color: '#718096',
  fontWeight: 500
}));

export const FieldValue = styled('span')(() => ({
  fontSize: '0.875rem',
  fontWeight: 600
}));

export const SectionBlock = styled('div')(() => ({
  marginBottom: '1.25rem'
}));

export const TradesRow = styled('div')(() => ({
  display: 'flex',
  gap: '0.5rem',
  flexWrap: 'wrap'
}));

export const TradeChipButton = styled('button')(({ selected }) => ({
  padding: '0.375rem 0.75rem',
  borderRadius: '9999px',
  fontSize: '0.875rem',
  fontWeight: 500,
  border: `1px solid ${selected ? '#4299e1' : '#cbd5e0'}`,
  background: selected ? '#4299e1' : '#fff',
  color: selected ? '#fff' : '#4a5568',
  cursor: 'pointer',
  transition: 'all 0.15s',
  '&:hover': {
    borderColor: '#4299e1'
  }
}));

export const SaveContainer = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'center'
}));

export const ModalFooter = styled('div')(() => ({
  display: 'flex',
  gap: '0.5rem',
  justifyContent: 'flex-end'
}));

export const AuditTable = styled('table')(() => ({
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '0.8125rem'
}));

export const AuditTh = styled('th')(() => ({
  textAlign: 'left',
  padding: '0.375rem 0.5rem',
  borderBottom: '1px solid #e2e8f0',
  color: '#718096',
  fontWeight: 500,
  whiteSpace: 'nowrap'
}));

export const AuditTd = styled('td')(() => ({
  padding: '0.375rem 0.5rem',
  borderBottom: '1px solid #edf2f7',
  color: '#2d3748',
  maxWidth: '180px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));

export const AuditActionCell = styled('td')(() => ({
  padding: '0.375rem 0.5rem',
  borderBottom: '1px solid #edf2f7',
  color: '#2d3748',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
  verticalAlign: 'top'
}));

export const AuditSectionHeader = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginBottom: '1rem',
  flexWrap: 'wrap'
}));

export const AuditPaginationRow = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.75rem',
  marginTop: '0.75rem',
  flexWrap: 'wrap'
}));
